import { User } from 'firebase/auth';

import EnrollmentApi, { NewEnrollmentData } from '../api/enrollmentApi';
import SkillData from '../types/skillData';

export default class EnrollmentService {
  public static async isUserEnrolledInSkill(user: User | null, skill: SkillData): Promise<boolean> {
    if (user === null) return false;
    const enrollment = await EnrollmentApi.getEnrollmentByUserAndSkill(user, skill);
    return !!enrollment;
  }

  public static async enrollUserInSkill(user: User, skill: SkillData): Promise<void> {
    const date = new Date();

    const newEnrollment: NewEnrollmentData = {
      userUuid: user.uid,
      skillId: skill.id,
      date: date.getTime(),
    };

    const enrollment = await EnrollmentApi.getEnrollmentByUserAndSkill(user, skill);
    if (!enrollment) {
      await EnrollmentApi.addEnrollment(newEnrollment);
    }
  }

  public static async getEnrolledSkillIds(user: User | null): Promise<string[]> {
    if (user === null) return [];
    const enrollments = await EnrollmentApi.getEnrollmentsByUser(user);
    return enrollments.map(enrollment => enrollment.skillId);
  }

  public static async getUserIdsEnrolledInSkill(skill: SkillData): Promise<string[]> {
    const enrollments = await EnrollmentApi.getEnrollmentsByModule(skill);
    return enrollments.map(enrollment => enrollment.userUuid);
  }
}
